import { cn } from "../../../../helpers/cn";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type BlogFiltersDividerProps = React.ComponentProps<"div">;

export const BlogFiltersDivider = ({
  className,
  ...props
}: BlogFiltersDividerProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <div
      style={{
        backgroundColor: colors.outline.outline,
      }}
      className={cn("h-10 w-[0.5px]", className)}
      {...props}
    />
  );
};
